import React, { PropTypes } from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';

import customer from '../../customer';
const {attemptTokenLogin} = customer.actions;

class App extends React.Component {
  componentWillMount() {
    this.props.attemptTokenLogin();
  }

  render() {
    return (
      <div id="wrapper">
        {this.props.children}
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({attemptTokenLogin}, dispatch);
}

App.propTypes = {
  attemptTokenLogin: PropTypes.func.isRequired,
  children: PropTypes.element
};

export default connect(null, mapDispatchToProps)(App);


/** WEBPACK FOOTER **
 ** ./src/modules/app/components/App.js
 **/